import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EmployeesRoutingModule } from "./employees-routing.module";
import { EmployeesComponent } from "./employees.component";
import { EmployeeListComponent } from "./employee-list/employee-list.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { EmployeesService } from "./employees.service";
import { StoreModule } from "@ngrx/store";
import { employeesReducer } from "./employees.reducer";
import { EffectsModule } from "@ngrx/effects";
import { EmployeesEffects } from "./employees.effects";
import { SharedModule } from "../shared/shared.module";
import { EmployeeRequestDialogComponent } from "./employee-request-dialog/employee-request-dialog.component";
import { EmployeeReviewDialogComponent } from "./employee-review-dialog/employee-review-dialog.component";
import { CurrentEmployeeFormComponent } from "./current-employee-form/current-employee-form.component";
import { EmployeeEditDialogComponent } from "./employee-edit-dialog/employee-edit-dialog.component";
import { EmployeeManagerComponent } from "./employee-manager/employee-manager.component";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatTooltipModule } from "@angular/material/tooltip";
@NgModule({
  declarations: [
    EmployeesComponent,
    EmployeeListComponent,
    EmployeeRequestDialogComponent,
    EmployeeReviewDialogComponent,
    CurrentEmployeeFormComponent,
    EmployeeEditDialogComponent,
    EmployeeManagerComponent,
  ],
  imports: [
    CommonModule,
    EmployeesRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    StoreModule.forFeature("employees", employeesReducer),
    EffectsModule.forFeature([EmployeesEffects]),
    MatButtonToggleModule,
    MatTabsModule,
    MatTableModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatRadioModule,
    MatTooltipModule,
  ],
  providers: [EmployeesService],
  exports: [EmployeeManagerComponent],
})
export class EmployeesModule {}
